import { ListProductDefinitions } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import {
  BooleanInput,
  Option,
  SelectWithFilter,
} from '@trufla-technology/trumarket-react-design-system';
import { useEffect, useState } from 'react';

type Props = {
  product: ListProductDefinitions[number];
  selected: boolean;
  teamsExperience?: { teamKey?: string; experience?: string };
  changeExperiences: (key: string, value: string) => void;
  handleSelect: (data: ListProductDefinitions[number]) => void;
  setDisabled: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AssignRequestCard = ({
  product,
  selected,
  handleSelect,
  teamsExperience,
  changeExperiences,
  setDisabled,
}: Props) => {
  const [experience, setExperience] = useState<string | undefined>(
    teamsExperience?.experience,
  );

  useEffect(() => {
    if (teamsExperience) {
      setExperience(teamsExperience.experience);
    }
  }, [teamsExperience]);

  const changeSchema = (experience: string) => {
    changeExperiences(product.key!, experience);
    setDisabled(false);
    setExperience(experience);
  };
  const handleSelectSchema = (isSelected: boolean) => {
    if (isSelected && !teamsExperience && !experience) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    if (!isSelected) {
      setExperience(undefined);
    }
    handleSelect(product);
  };

  return (
    <section className={`assign-request-card ${selected && 'selected'}`}>
      <article className="assign-request-card-header">
        <p className="request-title">{product.name}</p>
        <BooleanInput value={selected} onChange={handleSelectSchema} />
      </article>

      <article className="select-wrapper">
        <SelectWithFilter
          showSearch={false}
          value={experience}
          onChange={changeSchema}
          placeholder="Please select one schema"
          disabled={!selected}
        >
          <Option disabled value="">
            Please Select One Schema
          </Option>
          {
            //@ts-ignore
            product?.experiences
              ?.filter((exp: string) => exp !== 'publicUser')
              .map((option: string) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))
          }
        </SelectWithFilter>
      </article>
    </section>
  );
};
